<script lang="ts">
  import { getBlogImageAltTextFromUrl } from '../services/blog-data-services';
  import { blogBaseUrl } from '../store/blog_store';

  export let headerPost;
  $: blogImgUrl = headerPost?.blogHomepageHeaderImage || headerPost?.blogImage;
</script>

<a
  class="blog-variant1-section"
  href={`${$blogBaseUrl}/${headerPost?.blogCategoryid}/${headerPost?.blogPostKey}`}
  style={`background-image:url('${blogImgUrl}');background-size: cover;
                background-position: center;  background-repeat: no-repeat;`}
>
  <!-- This is a hack because semantically the alternate text is not on the element that actually has the image. 
       However, from a screen reader perspective the <div> with the background image is ignored and so placing the <span> 
       directly following it will provide that information in a way that will seem as if the alternate text was in the same place as the background image. -->
  <span role="img" aria-label={getBlogImageAltTextFromUrl(blogImgUrl)}> </span>
  <div class="content">
    {#if headerPost.blogTitle}
      <span class="title">{headerPost?.blogTitle}</span>
    {/if}
    {#if headerPost.blogSubTitle}
      <span class="sub-title">{headerPost?.blogSubTitle}</span>
    {/if}
  </div>
</a>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .blog-variant1-section {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    min-height: 265px;
    border-radius: 20px;
    @include desktop-max-width {
      min-height: 203px;
      border-radius: 0;
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 8px;
      color: $primary-white;
      text-align: left;
      justify-content: center;
      width: 60%;
      padding: 0 60px;
      text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      @include desktop-max-width {
        padding: 0 16px;
      }
      .title {
        font-size: 50px;
        font-weight: 700;
        line-height: 55px;
        @include desktop-max-width {
          font-size: 24px;
          line-height: 34px;
          font-weight: 700;
        }
      }
      .sub-title {
        color: $primary-white;
        font-size: 28px;
        font-weight: 400;
        line-height: 49px;
        @include desktop-max-width {
          font-size: 22px;
          line-height: 26px;
        }
      }
    }
    // :global(picture img){
    //     object-fit: fill !important;
    // }
  }
</style>
